import Store from '../store'
import { nextTick } from 'vue'

const debounceTimers = {}

const $formValuesProxy = new Proxy(
  {},
  {
    get: function (target, prop) {
      let propName = prop
      if (propName.substr(propName.length - 7) === ':change') {
        propName = propName.substr(0, propName.length - 7)
      }
      if (propName in Store.state.nette.$controls) {
        return Store.state.nette.$controls[propName].val
      } else {
        console.warn('$formValues control ' + propName + ' is not defined')
        return undefined
      }
    },
    set: function (target, prop, value) {
      let propName = prop
      let triggerChange = false
      if (propName.substr(propName.length - 7) === ':change') {
        propName = propName.substr(0, propName.length - 7)
        triggerChange = true
      }

      if (propName in debounceTimers) {
        clearTimeout(debounceTimers[propName])
      }

      Store.commit('nette/updateControl', {
        controlName: propName,
        data: value,
        key: 'val',
      })

      if (triggerChange) {
        nextTick(() => {
          let el = document.getElementById(propName)
          if (!el) {
            el = document.getElementById(`${propName}-${value}`)
          }

          if (el) {
            el.dispatchEvent(new Event('change', { bubbles: true }))
          }
        })
      }

      return true
    },
  }
)

export default $formValuesProxy
